import * as z from "zod";

export const getPotentialPointsForPurchase = {
  name: "getPotentialPointsForPurchase" as const,
  input: z.object({
    items: z.array(z.object({ productId: z.string(), price: z.number() })),
    customerId: z.string().optional(),
    storeUrl_forCacheRoutingOnly: z.string().optional(),
  }),
  output: z.object({ pointsToEarn: z.number() }),
};
